<p-dialog
    (onHide)="onHide()"
    (onShow)="onShow()"
    [(visible)]="visible"
    [appendTo]="appendTo"
    [contentStyle]="contentStyle"
    [dismissableMask]="dismissOnClickOutside"
    [draggable]="draggable"
    [minX]="minX"
    [minY]="minY"
    [modal]="blockBackground"
>
    <ng-template #header>
        {{ (existingJournal ? (readonly ? "journal.title" : "journal.journalDialogEdit") :
        "journal.journalDialogHeader") | translate:translationObject }}
    </ng-template>

    @if (manageJournalEntryForm) {
    <form
        class="p-16"
        [formGroup]="manageJournalEntryForm"
        autocomplete="off"
        novalidate
    >
        <div class="row">
            <div class="col-6">
                <div class="m-form-group row">
                    <label
                        class="col-4"
                        for="categoryId"
                    >
                        {{ "journal.category" | translate }}
                    </label>
                    <div class="col-8">
                        <p-select
                            id="categoryId"
                            (onChange)="setSelectedCategory($event.value)"
                            [options]="categories"
                            #categoryIdInput
                            appendTo="body"
                            formControlName="categoryId"
                            placeholder="{{'journal.category' | translate}}"
                        >
                        </p-select>
                        <app-form-validation
                            [control]="manageJournalEntryForm.get('categoryId')"
                            [input]="categoryIdInput"
                        >
                        </app-form-validation>
                    </div>
                </div>
                <div
                    class="m-form-group row"
                    [ngClass]="{ 'has-error': manageJournalEntryForm.get('timestamp').showErrors }"
                >
                    <label
                        class="col-4"
                        for="timestamp"
                    >
                        {{ "journal.timestamp" | translate }}
                    </label>
                    <div class="col-8">
                        <p-date-picker
                            id="timestamp"
                            [dateFormat]="calendarSettings.dateFormat"
                            [firstDayOfWeek]="calendarSettings.firstDayOfWeek"
                            [hourFormat]="calendarSettings.hourFormat"
                            [showIcon]="true"
                            [showTime]="true"
                            [style]="{'width':'100%'}"
                            #timestampInput
                            appendTo="body"
                            formControlName="timestamp"
                        ></p-date-picker>
                        <app-form-validation
                            [control]="manageJournalEntryForm.get('timestamp')"
                            [input]="timestampInput"
                        >
                        </app-form-validation>
                    </div>
                </div>
                @if (canSetSubCategory) {
                <div class="m-form-group row">
                    <label
                        class="col-4"
                        for="subCategoryId"
                    >
                        {{ "journal.subCategory" | translate }}
                    </label>
                    <div class="col-8">
                        <p-select
                            id="subCategoryId"
                            [options]="subCategories"
                            #subCategoryIdInput
                            appendTo="body"
                            formControlName="subCategoryId"
                            placeholder="{{'journal.subCategory' | translate}}"
                        >
                        </p-select>
                        <app-form-validation
                            [control]="manageJournalEntryForm.get('subCategoryId')"
                            [input]="subCategoryIdInput"
                        >
                        </app-form-validation>
                    </div>
                </div>
                } @if (canSetProject) {
                <div
                    class="m-form-group row"
                    [ngClass]="{ 'has-error': manageJournalEntryForm.get('projectId').showErrors }"
                >
                    <label
                        class="col-4"
                        for="projectId"
                    >
                        {{ "general.project" | translate }}
                    </label>
                    <div class="col-8">
                        <p-select
                            id="projectId"
                            [filter]="true"
                            [options]="projects"
                            [resetFilterOnHide]="true"
                            [showClear]="true"
                            [style]="{'width':'100%'}"
                            #projectIdInput
                            appendTo="body"
                            formControlName="projectId"
                            placeholder="{{'general.project' | translate}}"
                        >
                            <ng-template
                                let-project
                                pTemplate="item"
                            >
                                <span [ngClass]="project.styleClass">{{ project.label }}</span>
                            </ng-template>
                        </p-select>
                        <app-form-validation
                            [control]="manageJournalEntryForm.get('projectId')"
                            [input]="projectIdInput"
                        >
                        </app-form-validation>
                    </div>
                </div>
                }
                <div class="m-form-group row">
                    <label
                        [class]="readonly ? 'col-3' : 'col-4'"
                        for="remarks"
                    >
                        {{ "journal.remarks" | translate }}
                    </label>
                    @if (readonly) {
                    <app-svg-icon
                        class="col-1"
                        (click)="copyTextToClipboard(remarksInput)"
                        icon="copy"
                        style="cursor: pointer"
                    />
                    }
                    <div class="col-8">
                        <textarea
                            class="p-inputtextarea"
                            id="remarks"
                            #remarksInput
                            formControlName="remarks"
                            placeholder="{{'journal.remarks' | translate}}"
                            rows="5"
                        ></textarea>
                    </div>
                </div>
                @if (manageJournalEntryForm.get('adminRemarks')) {
                <div class="m-form-group row">
                    <label
                        [class]="readonly ? 'col-3' : 'col-4'"
                        for="adminRemarks"
                    >
                        {{ "journal.adminRemarks" | translate }}
                    </label>
                    @if (readonly) {
                    <app-svg-icon
                        class="col-1"
                        (click)="copyTextToClipboard(adminRemarksInput)"
                        icon="copy"
                        style="cursor: pointer"
                    />
                    }
                    <div class="col-8">
                        <textarea
                            class="p-inputtextarea"
                            id="adminRemarks"
                            #adminRemarksInput
                            formControlName="adminRemarks"
                            placeholder="{{'journal.adminRemarks' | translate}}"
                            rows="5"
                        ></textarea>
                    </div>
                </div>
                } @if (manageJournalEntryForm.get('isAdminOnly')) {
                <div class="m-form-group row">
                    <span class="col-4"> {{ "auditTrails.isAdminOnly" | translate }} </span>
                    <div class="col-8">
                        <p-toggle-switch formControlName="isAdminOnly"></p-toggle-switch>
                    </div>
                </div>
                }
            </div>
            <div class="col-6">
                <app-attachment-form
                    [context]="existingJournal"
                    [parentFormGroup]="manageJournalEntryForm"
                    [readonly]="readonly"
                ></app-attachment-form>
            </div>
        </div>
    </form>
    }

    <ng-template #footer>
        <ng-container>
            @if (!readonly) {
            <button
                class="m-btn m-btn-link"
                id="close_add_log_entry_dialog_button"
                (click)="close()"
                [disabled]="submitting"
                type="button"
            >
                {{ "form.cancel" | translate }}
            </button>
            }

            <button
                class="m-btn m-btn-primary"
                (click)="submit()"
                [disabled]="submitting"
                type="submit"
            >
                @if (submitting) {
                <app-loading-spinner />
                } {{ (readonly ? "form.close" : "form.save") | translate }}
            </button>
        </ng-container>
    </ng-template>
</p-dialog>
